import { runInAction } from 'mobx';
import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';
import { ReduxRawState } from './ReduxRawState';

const isNumber = createGuard(t.number);

const getHashCode = (marketsImmutable: unknown): number => {
    if (marketsImmutable === undefined) {
        return NaN;
    }

    try {
        //@ts-expect-error
        const hashCode = marketsImmutable.hashCode();

        if (isNumber(hashCode)) {
            return hashCode;
        }

        console.error('getHashCode - expected number', marketsImmutable);
    } catch (err) {
        console.error('getHashCode - error in getHashCode', err);
    }

    return NaN;
};

const toJS = (marketsImmutable: unknown): unknown => {
    if (marketsImmutable === undefined) {
        return undefined;
    }

    try {
        //@ts-expect-error
        return marketsImmutable.toJS();
    } catch (err) {
        console.error('error in toJS', err);
    }
};

/**
 * Use the 'ReduxRawState.getStateReactive' method
 * @returns
 */
export const reduxImmutableHash = (
    reduxStore: ReduxRawState,
    getImmutable: (data: Record<string, unknown>) => unknown,
    update: (data: unknown) => void
): void => {
    let lastHash: number = 0;

    const tryUpdate = (): void => {
        try {
            const marketsImmutable = getImmutable(reduxStore.getState());

            const hashCode = getHashCode(marketsImmutable);

            if (lastHash === hashCode) {
                //there has been no change, I am ignoring this event
            } else {
                lastHash = hashCode;

                const data: unknown = toJS(marketsImmutable);

                runInAction(() => {
                    update(data);
                });
            }
        } catch (err) {
            console.warn(err);
        }
    };

    tryUpdate();

    reduxStore.subscribe(tryUpdate);
};

// export
